<template>
    <div class="wrap">
        <div class="modal show" id="resetPwdError_popup">
            <div class="modal_box">
                <p class="modal_title">
                    {{ message }}
                </p>
                <div class="modal_btnbox">
                    <button type="button" class="modal_close btn" @click="goHome">확인</button>
                </div>
            </div>
        </div>

    </div>
</template>

<script setup>
import { useRoute } from 'vue-router';

const route = useRoute();
const message = route.params.message;

const goHome = () => {
    location.replace("/")
}
</script>

<style></style>